import {map} from 'rxjs/operators';
import {toUiMsg$} from '@/ui';
import {contractConditionalOrders$} from './order-conditional-contract';
import type {OrderData, ContractConditionalOrder} from '@/types';

export interface UOrdersConditionalContract {
  type: 'contract-orders-conditional';
  data: OrderData<ContractConditionalOrder>;
}

export function subscribeContractConditionalOrder() {
  contractConditionalOrders$
    .pipe(
      map<ContractConditionalOrder[], UOrdersConditionalContract>((orders) => ({
        type: 'contract-orders-conditional',
        data: {orders},
      }))
    )
    .subscribe((msg) => toUiMsg$.next(msg));
}
